export default __webpack_public_path__ + "static/media/L3Harris.663c2fab.png";